import { ArrowDownward, ArrowUpward, FilterAltOutlined, MoreVert } from '@mui/icons-material';
import { Box } from '@mui/material';
import { ColumnEvent, SortDirection } from 'ag-grid-community';
import type { CustomHeaderProps } from 'ag-grid-react';
import { ReactNode, useEffect, useRef, useState } from 'react';
import HeaderCellActionBar from './HeaderCellActionBar';
import HeaderCellButton from './HeaderCellButton';

export interface HeaderCellProps extends CustomHeaderProps {
    component?: ReactNode;
    maxLines?: number;
}

export default function HeaderCell({
    displayName,
    //setSort,
    column,
    enableFilterButton,
    enableMenu,
    enableSorting,
    showFilter,
    showColumnMenu,
    progressSort,
    component,
    maxLines
}: HeaderCellProps): ReactNode {

    const [sort, setSort] = useState<SortDirection | undefined>(column.getSort());
    const [filterActive, setFilterActive] = useState<boolean>(column.isFilterActive());
    //const [sortIndex, setSortIndex] = useState<number | undefined | null>(column.getSortIndex());
    const refMenu = useRef(null);
    const refFilter = useRef(null);

    function onMenuClicked() {
        showColumnMenu(refMenu.current!);
    }

    function onFilterClicked() {
        showFilter(refFilter.current!);
    }

    function onSortClicked(multiSort: boolean) {
        if (enableSorting) {
            progressSort(multiSort);
        }
    }

    useEffect(() => {
        function onSortChanged(event: ColumnEvent) {
            setSort(event.column?.getSort());
            //setSortIndex(event.column?.getSortIndex());
        };

        column.addEventListener('sortChanged', onSortChanged);

        return () => {
            column.removeEventListener('sortChanged', onSortChanged);
        };
    }, [
        column,
        displayName
    ]);

    //const sort = column.getSort();

    useEffect(() => {
        function onFilterActiveChanged(event: ColumnEvent) {
            setFilterActive(event.column?.isFilterActive()??false);
        };

        column.addEventListener('filterActiveChanged', onFilterActiveChanged);

        return () => {
            column.removeEventListener('filterActiveChanged', onFilterActiveChanged);
        };
    }, [column, displayName]);

    return (
        <Box
            sx={{
                position: "static"
            }}
            onClick={(event: { shiftKey: boolean; }) => onSortClicked(event.shiftKey)}
        >
            {component !== undefined
                ? <Box
                    sx={{
                        color: "text.primary",
                        cursor: enableSorting
                            ? "pointer"
                            : "auto"
                    }}
                >
                    {component}
                </Box>
                : <Box
                    sx={{
                        whiteSpace: "normal",
                        wordBreak: "normal",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        fontWeight: "bold",
                        color: "text.primary",
                        maxHeight: `calc((var(--ag-header-font-size) * 1.2 * ${maxLines ?? 3}))`,
                        cursor: enableSorting
                            ? "pointer"
                            : "auto"
                    }}
                >
                    {displayName}
                    {sort === 'asc' &&
                        <ArrowUpward fontSize="inherit" />
                    }
                    {sort === 'desc' &&
                        <ArrowDownward fontSize="inherit" />
                    }
                </Box>
            }

            <HeaderCellActionBar>
                {enableFilterButton &&
                    <HeaderCellButton
                        ref={refFilter}
                        onClick={() => onFilterClicked()}

                    >
                        <FilterAltOutlined
                            sx={{
                                fontSize: "calc(var(--ag-header-font-size) * 1.5)"
                            }}
                            color={filterActive ? "secondary" : "inherit"}
                        />
                    </HeaderCellButton>
                }
                {enableMenu &&
                    <HeaderCellButton
                        ref={refMenu}
                        onClick={onMenuClicked}
                    >
                        <MoreVert
                            sx={{
                                fontSize: "calc(var(--ag-header-font-size) * 1.5)"
                            }}
                        />
                    </HeaderCellButton>
                }
            </HeaderCellActionBar>
        </Box>
    );
};
